import Icon from './Icon';

const CheckedRadio = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon {...rest} viewBox="0 0 24 24">
      <rect x="2" y="2" width="20" height="20" rx="10" fill={color} />
      <rect
        x="8"
        y="8"
        width="8"
        height="8"
        rx="4"
        fill="var(--color-base-1)"
      />
    </Icon>
  );
};

export default CheckedRadio;
